import api from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    actions: [],
    userid: ''
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_USERID: (state, userid) => {
      state.userid = userid
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_ACTIONS: (state, actions) => {
      state.actions = actions
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      // console.log('444444444')
      const username = userInfo.UserName.trim()
      return new Promise((resolve, reject) => {
        // console.log('55555555555')
        api.login(username, userInfo.Password).then(response => {
          // console.log('66666666666')
          setToken(response.Data.Token)
          commit('SET_TOKEN', response.Data.Token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        api.getInfo(state.token).then(response => {
          const data = response.Data.Row
          if (data.UserActions && data.UserActions.length > 0) { // 验证返回的actions是否是一个非空数组
            commit('SET_ACTIONS', data.UserActions)
          } else {
            reject('getInfo: useraction must be a non-null array !')
          }
          commit('SET_NAME', data.UserName)
          commit('SET_USERID', data.UserID)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        api.logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_ACTIONS', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },

    // 修改后台用户密码
    UpdateAdminUserPassword({ commit }, params) {
      return new Promise((resolve, reject) => {
        api.updateAdminUserPassword(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js